var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":_vm.$cy.crmApp}},[_c('router-view'),_vm._v(" "),_c(_setup.LModal)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }